import React from 'react'

import SignUp from '../components/authentication/SignUp'

function Registration() {
  return (
    <div>
        <SignUp/>
    </div>
    
  )
}

export default Registration